/*
  •	Copyright (c) 2024 Pegasystems Inc.
  •	All rights reserved.
*/

/* action type */
import type { Action } from '../../store/state/state-manager';

export const CREATE_EXTERNAL_OBJECT = 'CREATE_EXTERNAL_OBJECT';

/* action creator */
export const createExternalObjectAction = (actionPayload: Action['payload']) => {
  return {
    type: CREATE_EXTERNAL_OBJECT,
    payload: actionPayload
  };
};
